{
  "version": 1,
  "asset_id": "577a8937-3e72-4eee-b477-1a847863684e",
  "project_id": "1e2975bf-5ed0-490a-887a-32746528c0b1",
  "url": "/__l5e/assets-v1/577a8937-3e72-4eee-b477-1a847863684e/logo-boa-forma.svg",
  "r2_key": "a/v1/1e2975bf-5ed0-490a-887a-32746528c0b1/577a8937-3e72-4eee-b477-1a847863684e/logo-boa-forma.svg",
  "original_filename": "logo-boa-forma.svg",
  "size": 3159,
  "content_type": "image/svg+xml",
  "created_at": "2026-09-21T21:42:04Z"
}
